export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4749.f5ceef2f.jpg";